import {LobbyImage} from '@colonist/types'
import {notificationController} from '../EntryShared'

export module UIMutePlayer {

    export const mutedPlayers: string[] = []

    export function toggleMuteForPlayer(playerName: string) {
        const isMuted = isMute(playerName)

        isMuted ? unmutePlayer(playerName) : mutePlayer(playerName)
        const notificationKey = isMuted ? 'strings:popups.notification.userUnmuted' : 'strings:popups.notification.userMuted'
        notificationController.showNotification(LobbyImage.Chat, {key: notificationKey, options: {username: playerName}}, 2000)
    }

    export function mutePlayer(playerName: string) {
        if(isMute(playerName)) return
        mutedPlayers.push(playerName)
    }

    export function unmutePlayer(playerName: string) {
        if(!isMute(playerName)) return
        const index = mutedPlayers.indexOf(playerName)
        mutedPlayers.splice(index, 1)
    }

    export function isMute(playerName: string): boolean {
        return mutedPlayers.includes(playerName)
    }
}
